export default function ($translate) {
    return [
        {
            KEY: 'EN',
            LABEL: $translate.instant('general.English')
        },
        {
            KEY: 'ET',
            LABEL: $translate.instant('general.Estonian')
        },
        {
            KEY: 'LV',
            LABEL: $translate.instant('general.Latvian')
        },
        {
            KEY: 'LT',
            LABEL: $translate.instant('general.Lithuanian')
        },
        {
            KEY: 'RU',
            LABEL: $translate.instant('general.Russian')
        }
    ];
}



// WEBPACK FOOTER //
// ./src/app/enums/forms/language/switcher/index.js